import { render, staticRenderFns } from "./point-create-page.vue?vue&type=template&id=37d5fef7&"
import script from "./point-create-page.vue?vue&type=script&lang=ts&"
export * from "./point-create-page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports